<mat-card>
  <mat-card-header class="full-width-header">
    <mat-card-title>
      <div class="title-row">
        <span>{{ 'AI_ASSISTANT.SETTINGS.SITUATIONS.TITLE' | translate }}</span>
        @if (situationConfigForm().dirty) {
        <span class="unsaved-changes-text">
          {{ 'AI_ASSISTANT.SHARED.UNSAVED_CHANGES.TITLE' | translate }}
        </span>
        }
      </div>
    </mat-card-title>
    <mat-card-subtitle>{{ 'AI_ASSISTANT.SETTINGS.SITUATIONS.DESCRIPTION' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    @if (situationConfigForm()) {
    <div [formGroup]="situationConfigForm()">
      <div formArrayName="situationMappings">
        @for (mapping of situationConfigForm().controls.situationMappings.controls; track mapping; let i = $index) {
        <div [formGroupName]="i" class="situation-mapping-row">
          <div class="form-controls-wrapper">
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.SITUATIONS.WHEN' | translate
                }}</glxy-label>
              <input matInput formControlName="situation" type="text" />
            </glxy-form-field>
            <glxy-form-field [required]="true">
              <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.SITUATIONS.USE' | translate }}</glxy-label>
              <mat-chip-grid #chipGrid
                [attr.aria-label]="'AI_ASSISTANT.SETTINGS.SITUATIONS.USE' | translate">
                @for (selectedCapability of getSelectedCapabilities(mapping); track selectedCapability.capabilityKey.id)
                {
                <mat-chip-row [removable]="true"
                  (removed)="removeCapability(mapping, selectedCapability.capabilityKey)">
                  {{ selectedCapability.name }}
                  <button matChipRemove
                    [attr.aria-label]="'AI_ASSISTANT.SETTINGS.SITUATIONS.REMOVE_CAPABILITY' | translate: { name: selectedCapability.name }">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
                }
                <input type="text" [formControl]="getSearchControl(mapping)" [matChipInputFor]="chipGrid"
                  [matAutocomplete]="auto" />
              </mat-chip-grid>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addCapability(mapping, $event)">
                @for (option of getFilteredCapabilities(mapping); track option.capabilityKey.id) {
                <mat-option [value]="option">{{ option.name }}</mat-option>
                }
              </mat-autocomplete>
            </glxy-form-field>
          </div>
          <mat-icon class="remove-button" (click)="removeSituationMapping(i)">close</mat-icon>
        </div>
        }
        @if (situationConfigForm().controls.situationMappings.controls.length === 0) {
        <p class="empty-state">{{ 'AI_ASSISTANT.SETTINGS.SITUATIONS.NO_SITUATIONS_CONFIGURED' | translate }}</p>
        }
      </div>
    </div>
    }
  </mat-card-content>
  <mat-card-footer class="card-footer">
    <button mat-stroked-button type="button" (click)="addSituationMapping()">
      <mat-icon>add</mat-icon>
      {{ 'AI_ASSISTANT.SETTINGS.SITUATIONS.ADD_SITUATION' | translate }}
    </button>
  </mat-card-footer>
</mat-card>
